import { Loader as UILoader } from "@circle-react-uikit/Loader";

export const Loader = () => (
  <div className="absolute inset-0 flex items-center justify-center">
    <UILoader />
  </div>
);
